import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '@/store';
// import { TaLog } from '@/utils';
import pc from '@/views/pc';
import dataCollect from '@/components/pc/myCollect';
import detail from '@/components/pc/detail';
import mobile from '@/views/mobile';
import mdetail from '@/components/mobile/mDetail';
import myCollect from '@/components/mobile/mMyCollect';
import noNet from '@/components/mobile/noNet';
Vue.use(VueRouter);

// 解决报错
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  // if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    console.log(err);
    originalPush.call(this, location, onResolve, onReject);
  });
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  console.log(onReject + onResolve);
  // if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    console.log(err);
    originalPush.call(this, location, onResolve, onReject);
  });
};
const router = new VueRouter({
  // mode: 'history',
  // base: base,
  routes: [{
    path: '/',
    redirect: '/dataImage'
  }, {
    path: '/collect',
    component: myCollect
  }, {
    path: '/detail',
    component: mdetail
  }, {
    path: '/list',
    component: mobile
  }, {
    path: '/dataImage',
    component: pc
  }, {
    path: '/dataDetail',
    component: detail
  }, {
    path: '/dataCollect',
    component: dataCollect
  }, {
    path: '/noNet',
    component: noNet
  }]
});
export default router;